import React from "react"
import { Fade } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"
import "./Slideshow.css"

const fadeImages = [
  {
    image: window.location.origin + "/loadingImages/staridizajn-frontview.jpg",
  },
  {
    image: window.location.origin + "/loadingImages/staridizajn-sideview.jpg",
  },
]

/* <div style={{ backgroundImage: `url(${slideImages[0]})` }}> */
const Slideshow = () => {
  return (
    <div>
      <div className="logo-wrap">
        <div className="logo-container">
          <img src={window.location.origin + "/gtc-x-logo.png"} alt="" />
        </div>
        <div className="logotip-container">
          <img src={window.location.origin + "/gtc-x-logotip.png"} alt="" />
        </div>
      </div>
      <Fade
        indicators={false}
        duration={3000}
        transitionDuration={500}
        pauseOnHover={false}
        arrows={false}
        defaultIndex={0}
        canSwipe={false}
      >
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[0].image} />
          </div>
        </div>
        <div className="each-fade">
          <div className="image-container">
            <img src={fadeImages[1].image} />
          </div>
        </div>
      </Fade>
    </div>
  )
}

export default Slideshow
